import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import Thanks from './Thanks';

export default compose(withRouter)(Thanks);
